import React, { Component } from 'react'
import { push, goBack } from 'react-router-redux';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import shortid from 'shortid'
import { parseString } from 'dxf'
import NavigationPrompt from "react-router-navigation-prompt";

import './ConfirmExitModal.css';

import Button from '../../components/Button/Button.js'

import { leavePattern, tryToCreateNewPattern, tryToUpdatePattern, setTrayOpen, forgetChanges } from '../../actions/actions.export.js';

class ConfirmExitModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      when: false
    }

    this.handleLeave = this.handleLeave.bind(this);
    this.handleSaveAndLeave = this.handleSaveAndLeave.bind(this);
  }

  handleLeave(cb){
    const { dispatch, cacheID, patternManager } = this.props;

    if(patternManager.current_pattern !== 'local'){
      dispatch(forgetChanges({
        id: patternManager.current_pattern
      }))
    }
    dispatch(leavePattern(new Date().toISOString()));
    dispatch(setTrayOpen({tray: "saved", open: false}));
    dispatch(setTrayOpen({tray: "library", open: false}));

    return cb();
  }

  handleSaveAndLeave(cb){
    const { patternManager, dispatch, user, team, globalReducer } = this.props;
    const pattern = patternManager.cache[patternManager.current_pattern];
    const cacheID = patternManager.current_pattern;

    var owned_by_you = false;
    var team_id;

    if(user.isLoggedIn){
      if(team.current && team.cache[team.current]){
        team_id = team.cache[team.current].id;
      }

      if(pattern.scope === team_id && team.current){
        owned_by_you = true;  
      }

      if(pattern.scope === user.id && !team.current){
        owned_by_you = true;
      }
    }
    
    if(user.isLoggedIn && !owned_by_you){
      dispatch(tryToCreateNewPattern(pattern)) 
    } else if(user.isLoggedIn && owned_by_you){
      dispatch(tryToUpdatePattern(pattern))
    } 
    dispatch(setTrayOpen({tray: "saved", open: false}));
    dispatch(setTrayOpen({tray: "library", open: false}));
    return cb();
  }

  componentWillReceiveProps(newprops){
    // console.log('newprops', newprops.when);
    this.setState({
      when: newprops.when
    })
  }

  render(){
    const { dispatch, globalReducer, patternManager, cacheID, user } = this.props; 
    
    var pattern = patternManager.cache[cacheID];

    // console.log(this.state.when)
    if(!this.state.when) return "";

    return <NavigationPrompt
        
        // Children will be rendered even if props.when is falsey and isActive is false:
        renderIfNotActive={false}

        // Confirm navigation if going to a path that does not start with current path:
        when={(crntLocation, nextLocation) => {
          if(nextLocation.pathname.indexOf('/new/imported') > -1 && crntLocation.pathname.indexOf('/new/imported') === -1){
            return false;
          }

          return this.state.when;// && (!nextLocation || !nextLocation.pathname.startsWith(crntLocation.pathname))
        }}
      >
        {({ isActive, onCancel, onConfirm }) => {
          if (isActive) {
            return (
              <div className="modal theme-light">
                <div className="modal-bg" onClick={onCancel}>
                </div>
                <div className="modal-inner">
                  <div className="flex-split">
                    <span>
                      
                    </span>
                    <span>
                      <Button size="squared-normal" color="borderless" display={<i className="fal fa-times fa-lg fa-fw"/>} onClick={onCancel}/> 
                    </span>
                  </div>
                  <div className="flex-column">
                    <i className="fad fa-file-exclamation fa-5x text-secondary"/><br/>
                    <h4>Your changes aren't saved!</h4>
                    {
                      user.isLoggedIn ? 
                      <p className="text-center">
                        If you leave without saving, your changes will be lost.<br/>Are you sure you want to leave?
                      </p>
                      :
                      <p className="text-center" style={{maxWidth: 400}}>
                        Create an free account to save your pattern and access it anytime! If you leave without saving, your changes will be lost.<br/>Are you sure you want to leave?
                      </p>
                    }
                  </div>
                  <br/>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="flex-split">
                        <span className="list-item">
                          <Button
                            display="Stay"
                            color="grey"
                            size="medium"
                            onClick={onCancel}
                            />
                        </span>
                        <span className="list-right">
                          <span className="list-item">
                            <Button
                              display="Leave"
                              color="danger"
                              size="medium"
                              onClick={(e)=>{ this.handleLeave(onConfirm) }}
                              />
                          </span>
                          {
                            // user.isLoggedIn &&
                            // <span className="list-item">
                            //   <Button
                            //     display="Save & Leave"
                            //     color="success"
                            //     thinking={(patternManager.tryingToUpdatePattern || patternManager.tryingToCreateNewPattern)}
                            //     size="medium"
                            //     onClick={(e)=>{ this.handleSaveAndLeave(onConfirm) }}
                            //     />
                            // </span>
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          };
        }}
      </NavigationPrompt>;
  }
}

const mapStateToProps = (state) => {
  const { globalReducer, patternManager, user, team } = state;

  return {
    globalReducer, patternManager, user, team
  }
}

export default connect(mapStateToProps)(ConfirmExitModal);



// WEBPACK FOOTER //
// ./src/components/ConfirmExitModal/ConfirmExitModal.js